// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"5f081c31","977":"f06018d8"}[chunkId] + ".chunk.js";
};